angular.module('satv.media')

.factory('DownloadQueueModal', ['config', 'Modal', function(config, Modal) {
    return {
        open: function(params, data) {
            return Modal.create(
                config.templateRoot + '/media/download/queue-modal',
                params,
                data
            );
        }
    };
}]);



// WEBPACK FOOTER //
// ./vendor/sonyatv/mediaclientbundle/Resources/js/angular/services/DownloadQueueModal.js